import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking"); // checking, paid, timeout
  const nav = useNavigate();

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("timeout"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); await refresh(); return; }
      } catch {}
      if (++tries >= 8) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, []); // eslint-disable-line

  return (
    <div className="max-w-lg mx-auto px-5 py-24 text-center">
      {state === "checking" && (<><Loader2 className="w-10 h-10 text-[#2C4C3B] mx-auto animate-spin mb-4" /><h1 className="font-serif-display text-3xl text-[#0F172A]">Confirming your payment…</h1><p className="text-[#475569] mt-2">This only takes a moment.</p></>)}
      {state === "paid" && (<><CheckCircle2 className="w-14 h-14 text-[#2C4C3B] mx-auto mb-4" /><h1 className="font-serif-display text-4xl text-[#0F172A]">Welcome to Premium</h1><p className="text-[#475569] mt-3">You now have unlimited Wisdom Paths, AI situation analysis, journaling, and premium downloads.</p><Link to="/" data-testid="premium-home-btn" className="inline-block mt-6 px-6 py-3 rounded-full bg-[#2C4C3B] text-white font-semibold">Find wisdom now</Link></>)}
      {state === "timeout" && (<><Loader2 className="w-10 h-10 text-[#B8912F] mx-auto mb-4" /><h1 className="font-serif-display text-3xl text-[#0F172A]">Still processing</h1><p className="text-[#475569] mt-2">Your payment is being finalized. Check your Account in a moment.</p><Link to="/account" className="inline-block mt-6 px-6 py-3 rounded-full border border-[#2C4C3B] text-[#2C4C3B] font-semibold">Go to Account</Link></>)}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-5 py-24 text-center">
      <XCircle className="w-14 h-14 text-[#94A3B8] mx-auto mb-4" />
      <h1 className="font-serif-display text-3xl text-[#0F172A]">Checkout canceled</h1>
      <p className="text-[#475569] mt-2">No charge was made. You can upgrade any time.</p>
      <Link to="/pricing" className="inline-block mt-6 px-6 py-3 rounded-full bg-[#2C4C3B] text-white font-semibold">Back to Pricing</Link>
    </div>
  );
}
